import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureTypeChildIconComponent } from './feature-type-child-icon.component';

@NgModule({
  declarations: [FeatureTypeChildIconComponent],
  imports: [CommonModule],
  exports: [FeatureTypeChildIconComponent],
})
export class FeatureTypeChildIconModule {}
